import { render } from "./PreScheduleFormQuestionModal.vue?vue&type=template&id=5ff67cdf&scoped=true"
import script from "./PreScheduleFormQuestionModal.vue?vue&type=script&lang=js"
export * from "./PreScheduleFormQuestionModal.vue?vue&type=script&lang=js"

import "./PreScheduleFormQuestionModal.vue?vue&type=style&index=0&id=5ff67cdf&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff67cdf"]])

export default __exports__